module.exports = __webpack_public_path__ + "img/Receive.f32a3ae5.png";